import React from 'react';
import { comingSoon } from '../../data/websites';
export function ComingSoon() {
  return <section aria-labelledby="coming-soon" className="border-t border-gray-200 bg-gray-50 px-[clamp(1rem,4vw,6rem)] py-12" data-id="element-818" data-mp="23rby7idgocgd">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:gap-10" data-id="element-819" data-mp="1oshy9v50dp7s">
        <h2 id="coming-soon" className="flex-shrink-0 text-sm font-bold uppercase tracking-[0.14em] text-brand-gray" data-id="element-820" data-mp="1trtg77h430qy">
          Coming soon
        </h2>
        <ul className="flex flex-wrap gap-2" data-id="element-821" data-mp="1fz4utz9bj57g">
          {comingSoon.map(item => <li key={item} className="inline-flex items-center gap-2 rounded-full border border-dashed border-gray-300 bg-white px-4 py-2 text-sm text-brand-gray" data-id="element-822" data-mp="1kt93qo259nb6">
              {item}
              <span className="rounded-full bg-brand-light px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-brand-gray" data-id="element-823" data-mp="x2bzzyki5wb0">
                Coming soon
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}